import { BlogSectionType } from '../../models/Content';

export const transformBlogSection = (content: BlogSectionType) => {
    return {
        type: content.fields.type,
    };
};
